import { SubmitHandler, useForm } from 'react-hook-form';
import axiosInstance from 'services/axiosInstance';
import * as S from './styled';
//Components
import ActionButton from '../../../Button/ActionButton';
import Delete from '../../../Delete';
import LayoutWithList from '../../../LayoutModal/WithList';
import Loading from "../../../Loading";
import Toast from '../../../Toast';
import Update from '../Update';
//hooks
import { useEffect, useState } from 'react';
import apiRequest from '../../../../hooks/apiRequest';
import useLoading from "../../../../hooks/useLoading";
import { useMultipleModal } from '../../../../hooks/useMultipleModal';
//Icons
import { PencilSimple, Trash } from '@phosphor-icons/react';
//Interfaces
import { ICreate } from 'Interfaces/ICreate';
import { ISensitivity, Inputs } from 'Interfaces/ISensitivity';

export default function CreateSensitivity({
  isOpenModal: isOpenModalData,
  setModalClose,
  refreshFrames,
  setToastOpen,
  setToastData
}: ICreate) {
  const {
    register,
    handleSubmit: handleFormSubmit,
    reset,
    formState: { errors },
  } = useForm<Inputs>();

  const { isLoading, startLoading, stopLoading } = useLoading();
  const { isOpenModal, toggleModalVisibility } = useMultipleModal();
  const tableHead = ["#", "Nome", "Ações"];
  const [data, setData] = useState<ISensitivity[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [hasNewData, setHasNewData] = useState(false);
  const [toastDataUpdate, setToastDataUpdate] = useState({
    status: 200,
    message: "",
  });

  const clickPopTable = (id: number, acao: string) => {
    setOpenModalOptId(id);
    toggleModalVisibility(acao);
  };

  const fetchData = async () => {
    startLoading()
    try {
      const response = await axiosInstance.get(`sensitivity`);
      setData(response.data);
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalData) {
      const debounceFetch = setTimeout(() => {
        fetchData();
      }, 300);

      return () => clearTimeout(debounceFetch);
    }
  }, [isOpenModalData]);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    try {
      const payload = {
        ...data,
        sensitivity: data.sensitivity.toLocaleUpperCase(),
      }
      const response = await apiRequest("sensitivity", "POST", payload);
      const status = response.status;
      if (status === 201) {
        setToastData({
          status: status,
          message: 'Cadastrado com sucesso!',
        });

        setHasNewData(true);
        setToastOpen(true);
        fetchData();
      }
    } catch (error: any) {
      setToastData({
        status: error?.response?.status || 500,
        message: error.message || 'Erro inesperado',
      });

      setToastOpen(true);
    }
  };

  const onClose = () => {
    setModalClose();
    reset();

    if (hasNewData) {
      refreshFrames();
      setHasNewData(false);
      toggleModalVisibility('open-toast');
    }
  }

  const handleRefreshFrames = () => {
    fetchData();
    setHasNewData(true);
  };

  if (isOpenModalData) {
    return (
      <LayoutWithList
        title="Registrar Fotossensibilidade"
        subTitle="Cadastre uma nova fotossensibilidade em sua base de dados."
        setModalClose={onClose}
      >
        <S.Container>
          <S.SeparateDiv>
            <S.FormInput>
              <S.Label>
                Fotossensibilidade
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe a fotossensibilidade"
                type="text"
                {...register("sensitivity", { required: true })}
              />
              {errors.sensitivity && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.ContentButton>
              <ActionButton
                name="Salvar"
                onClick={handleFormSubmit(onSubmit)}
              />
            </S.ContentButton>
          </S.SeparateDiv>
        </S.Container>

        <S.Footer>
          <S.TitleList>Sensibilidades Cadastradas</S.TitleList>
          {isLoading ? (
            <Loading />
          ) : (
            <S.Table>
              <thead>
                <tr>
                  {tableHead.map((val) => {
                    return <th>{val}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {data.map((val, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{val.sensitivity}</td>
                      <td>
                        <S.ContentButton>
                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "update")}
                          >
                            <PencilSimple size={20} />
                          </S.ButtonIconTable>

                          <S.ButtonIconTable
                            onClick={() => clickPopTable(val.id, "delete")}
                          >
                            <Trash size={20} color="red" />
                          </S.ButtonIconTable>
                        </S.ContentButton>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </S.Table>
          )}
        </S.Footer>

        <Update
          isOpenModal={isOpenModal("update")}
          setModalClose={() => toggleModalVisibility("update")}
          selectedUrlId={openModalOptId}
          refreshFrames={handleRefreshFrames}
          setToastOpen={() => toggleModalVisibility('open-toast')}
          setToastData={setToastDataUpdate}
        />
        <Toast
          openToast={isOpenModal('open-toast')}
          closeToast={() => toggleModalVisibility('open-toast')}
          message={toastDataUpdate.message}
          status={toastDataUpdate.status}
        />
        <Delete
          updateList={fetchData}
          endpoint="sensitivity"
          selectedProductId={openModalOptId}
          isOpenModal={isOpenModal("delete")}
          setModalClose={() => toggleModalVisibility("delete")}
        />
      </LayoutWithList>
    );
  }
  return null;
}